import { render, staticRenderFns } from "./CreateEvent.vue?vue&type=template&id=2ad5c1b5"
import script from "./CreateEvent.vue?vue&type=script&lang=js"
export * from "./CreateEvent.vue?vue&type=script&lang=js"
import style0 from "./CreateEvent.vue?vue&type=style&index=0&id=2ad5c1b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports